import axios from 'axios'
import { cloneDeep } from 'lodash-es'

import { cleanBlankValue } from 'utils/helper'

export const financeReportingsGraphs = (params) => {
  return axios.get('/finance/reportings/graphs', { params })
}

export const attachmentsReports = (params) => {
  return axios.get('/reportings/attachments', { params })
}

export const exportsReports = (params) => {
  return axios.get('/reportings/exports', { params })
}

export const importsReports = (params) => {
  return axios.get('/reportings/imports', { params })
}

export const importsDetailReports = (id) => {
  return axios.get(`/reportings/imports/${id}`)
}

export const importsTransactionsReports = ({ payload, id }) => {
  return axios.get(`/reportings/imports/${id}/transactions`, { params: payload })
}

export const salesPerPersonReports = (params) => {
  return axios.get('/reportings/salesPerPerson', { params })
}

export const getSalesPerPersonReportsWaTemplate = (params) => {
  return axios.get('/reportings/salesPerPerson/whatsapp', { params })
}

export const getSalesPerPersonReportsEmailTemplate = (params) => {
  return axios.get('/reportings/salesPerPerson/email', { params })
}

export const sendSalesPerPersonReportsEmail = (params, data) => {
  return axios.post('/reportings/salesPerPerson/email', data, { params })
}

export const salesPerPersonDailyReports = (params) => {
  return axios.get('/reportings/salesPerPersonDaily', { params })
}

export const exportSalesPerPersonReports = (params) => {
  const query = cloneDeep(params)
  query.export = params.type
  query.type = null

  return axios.get('/reportings/salesPerPerson', {
    responseType: 'arraybuffer',
    params: cleanBlankValue(query),
  })
}

export const shippingCostPerExpeditionReports = (params) => {
  return axios.get('/reportings/shippingCostPerExpedition', { params })
}

export const getShippingCostPerExpeditionReportsWaTemplate = (params) => {
  return axios.get('/reportings/shippingCostPerExpedition/whatsapp', { params })
}

export const getShippingCostPerExpeditionReportsEmailTemplate = (params) => {
  return axios.get('/reportings/shippingCostPerExpedition/email', { params })
}

export const sendShippingCostPerExpeditionReportsEmail = (params, data) => {
  return axios.post('/reportings/shippingCostPerExpedition/email', data, { params })
}

export const shippingCostPerExpeditionDailyReports = (params) => {
  return axios.get('/reportings/shippingCostPerExpeditionDaily', { params })
}

export const exportShippingCostPerExpeditionReports = (params) => {
  return axios.get('/reportings/shippingCostPerExpedition', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const inventorySummaryReports = (params) => {
  return axios.get('/reportings/inventorySummary', { params })
}

export const exportInventorySmmaryReports = (params) => {
  return axios.get('/reportings/inventorySummary', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const inventorySummaryFifoReports = (params) => {
  return axios.get('/reportings/inventorySummaryFifo', { params })
}

export const exportInventorySummaryFifoReports = (params) => {
  return axios.get('/reportings/inventorySummaryFifo', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const inventorySummaryDetailFifoReports = (params) => {
  return axios.get('/reportings/inventorySummaryDetailFifo', { params })
}

export const inventoryStockMovementReports = (params) => {
  return axios.get('/reportings/inventoryStockMovement', { params })
}

export const grandTotalInventoryStockMovementReports = (params) => {
  return axios.get('/reportings/inventoryStockMovement/grandTotal', { params })
}

export const exportInventoryStockMovementReports = (params) => {
  const query = cloneDeep(params)
  query.export = params.type
  query.type = null

  return axios.get(`/reportings/inventoryStockMovement`, {
    responseType: 'arraybuffer',
    params: cleanBlankValue(query),
  })
}

export const inventoryStockMovementDetailReports = (params) => {
  return axios.get('/reportings/inventoryStockMovementDetail', { params })
}

export const inventoryStockMovementFifoReports = (params) => {
  return axios.get('/reportings/inventoryStockMovementFifo', { params })
}

export const exportInventoryStockMovementFifoReports = (params) => {
  const query = cloneDeep(params)
  query.export = params.type
  query.type = null

  return axios.get('/reportings/inventoryStockMovementFifo', {
    responseType: 'arraybuffer',
    params: cleanBlankValue(query),
  })
}

export const inventoryStockMovementDetailFifoReports = (params) => {
  return axios.get('/reportings/inventoryStockMovementDetailFifo', { params })
}

export const inventoryStockAdjustmentReports = (params) => {
  return axios.get('/reportings/inventoryStockAdjustment', { params })
}

export const productStockMovementReports = (params) => {
  return axios.get('/reportings/productStockMovement', { params })
}

export const exportProductStockMovementReports = (params) => {
  return axios.get(`/reportings/productStockMovement`, {
    responseType: 'arraybuffer',
    params: cleanBlankValue(params),
  })
}

export const inventoryStockAdjustmentReportsWaTemplate = (params) => {
  return axios.get('/reportings/inventoryStockAdjustment/whatsapp', { params })
}

export const inventoryStockAdjustmentReportsEmailTemplate = (params) => {
  return axios.get('/reportings/inventoryStockAdjustment/email', { params })
}

export const sendInventoryStockAdjustmentReportsEmail = (params, data) => {
  return axios.post('/reportings/inventoryStockAdjustment/email', data, { params })
}

export const exportInventoryStockAdjustmentReports = (params) => {
  return axios.get('/reportings/inventoryStockAdjustment', {
    params,
    responseType: 'arraybuffer',
  })
}

export const inventoryStockAdjustmentDetailReports = (params) => {
  return axios.get('/reportings/inventoryStockAdjustmentDetail', { params })
}

export const lowStockReports = (params) => {
  return axios.get('/reportings/lowStock', { params })
}

export const lowStockReportsWaTemplate = (params) => {
  return axios.get('/reportings/lowStock/whatsapp', { params })
}

export const lowStockReportsEmailTemplate = (params) => {
  return axios.get('/reportings/lowStock/email', { params })
}

export const sendLowStockReportsEmail = (params, data) => {
  return axios.post('/reportings/lowStock/email', data, { params })
}

export const warehouseProductQuotaReports = (params) => {
  return axios.get('/reportings/warehouseProductQuota', { params })
}

export const warehouseProductQuotaReportsWaTemplate = (params) => {
  return axios.get('/reportings/warehouseProductQuota/whatsapp', { params })
}

export const warehouseProductQuotaReportsEmailTemplate = (params) => {
  return axios.get('/reportings/warehouseProductQuota/email', { params })
}

export const sendWarehouseProductQuotaReportsEmail = (params, data) => {
  return axios.post('/reportings/warehouseProductQuota/email', data, { params })
}

export const inventoryWarehouseTransferReports = (params) => {
  return axios.get('/reportings/inventoryWarehouseTransfer', { params })
}

export const inventoryWarehouseTransferReportsWaTemplate = (params) => {
  return axios.get('/reportings/inventoryWarehouseTransfer/whatsapp', { params })
}

export const inventoryWarehouseTransferReportsEmailTemplate = (params) => {
  return axios.get('/reportings/inventoryWarehouseTransfer/email', { params })
}

export const sendInventoryWarehouseTransferReportsEmail = (params, data) => {
  return axios.post('/reportings/inventoryWarehouseTransfer/email', data, { params })
}

export const exportInventoryWarehouseTransferReports = (params) => {
  return axios.get('/reportings/inventoryWarehouseTransfer', {
    params,
    responseType: 'arraybuffer',
  })
}

export const inventoryWarehouseTransferDetailReports = (params) => {
  return axios.get('/reportings/inventoryWarehouseTransfer/detail', { params })
}

export const warehouseStockSummaryReports = (params) => {
  return axios.get('/reportings/warehouseStock', { params })
}

export const massExportWarehouseStockSummaryReports = (params) => {
  return axios.get('/reportings/warehouseStock/massExport', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const productionReports = (payload) => {
  return axios.get('/reportings/production', { params: payload })
}

export const productionRawMaterialStatsReports = (payload) => {
  return axios.get('/reportings/productionRawMaterialStats', { params: payload })
}

export const productionAuditReports = (payload) => {
  return axios.get('/reportings/productionAudit', { params: payload })
}

export const exportProductionAuditReports = (params) => {
  return axios.get('/reportings/productionAudit', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getProductionAuditReportsWaTemplate = (payload) => {
  return axios.get('/reportings/productionAudit/whatsapp', { params: payload })
}

export const getProductionAuditReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/productionAudit/email', { params: payload })
}

export const sendProductionAuditReportsEmail = (payload, data) => {
  return axios.post('/reportings/productionAudit/email', data, { params: payload })
}

export const getProductionReportsWaTemplate = (payload) => {
  return axios.get('/reportings/production/whatsapp', { params: payload })
}

export const getProductionReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/production/email', { params: payload })
}

export const sendProductionReportsEmail = (payload, data) => {
  return axios.post('/reportings/production/email', data, { params: payload })
}

export const exportProductionReports = (params) => {
  return axios.get('/reportings/production', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const guestReports = (payload) => {
  return axios.get('/reportings/guest', { params: payload })
}

export const occupancyReports = (payload) => {
  return axios.get('/reportings/occupancy', { params: payload })
}

export const bookingReports = (payload) => {
  return axios.get('/reportings/booking', { params: payload })
}

export const revenueReports = (payload) => {
  return axios.get('/reportings/revenue', { params: payload })
}

export const closureReports = (payload) => {
  return axios.get('/reportings/closure', { params: payload })
}

export const channelReports = (payload) => {
  return axios.get('/reportings/channel', { params: payload })
}

export const posReports = (payload) => {
  return axios.get('/reportings/pos', { params: payload })
}

export const posSalesReports = (payload) => {
  return axios.get('/reportings/pos/sales', { params: payload })
}

export const generalLedgerReports = (payload) => {
  return axios.get('/reportings/generalLedger', { params: payload })
}

export const subsidiaryLedgerReports = (payload) => {
  return axios.get('/reportings/subsidiaryLedger', { params: payload })
}

export const exportSubsidiaryLedgerReports = (params) => {
  return axios.get('/reportings/subsidiaryLedger', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const generalLedgerAccountsReports = (payload) => {
  return axios.get('/reportings/generalLedgerAccounts', { params: payload })
}

export const generalLedgerAccountsDetailReports = (accountId, payload) => {
  return axios.get(`/reportings/generalLedgerAccounts/${accountId}/detail`, { params: payload })
}

export const generalLedgerStatsReports = (payload) => {
  return axios.get('/reportings/generalLedger/stats', { params: payload })
}

export const getGeneralLedgerReportsWaTemplate = (payload) => {
  return axios.get('/reportings/generalLedger/whatsapp', { params: payload })
}

export const getGeneralLedgerReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/generalLedger/email', { params: payload })
}

export const sendGeneralLedgerReportsEmail = (payload, data) => {
  return axios.post('/reportings/generalLedger/email', data, { params: payload })
}

export const generalLedgerCategoryReports = (payload) => {
  return axios.get('/reportings/generalLedger/categories', { params: payload })
}

export const journalReports = (payload) => {
  return axios.get('/reportings/journal', { params: payload })
}

export const exportJournalReports = (params) => {
  return axios.get('/reportings/journal', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getJournalReportsWaTemplate = (payload) => {
  return axios.get('/reportings/journal/whatsapp', { params: payload })
}

export const getJournalReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/journal/email', { params: payload })
}

export const sendJournalReportsEmail = (payload, data) => {
  return axios.post('/reportings/journal/email', data, { params: payload })
}

export const bankSummaryReports = (payload) => {
  return axios.get('/reportings/bankSummary', { params: payload })
}

export const getBankSummaryReportsWaTemplate = (payload) => {
  return axios.get('/reportings/bankSummary/whatsapp', { params: payload })
}

export const getBankSummaryReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/bankSummary/email', { params: payload })
}

export const sendBankSummaryReportsEmail = (payload, data) => {
  return axios.post('/reportings/bankSummary/email', data, { params: payload })
}

export const exportBankSummaryReports = (params) => {
  return axios.get('/reportings/bankSummary', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const salesTaxReports = (payload) => {
  return axios.get('/reportings/salesTax', { params: payload })
}

export const exportSalesTaxReports = (params) => {
  return axios.get('/reportings/salesTax', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const salesTaxDetailReports = (payload) => {
  return axios.get('/reportings/salesTaxDetail', { params: payload })
}

export const customerInvoiceReports = (payload) => {
  return axios.get('/reportings/customerInvoice', { params: payload })
}

export const customerInvoiceDetailReports = (payload) => {
  return axios.get('/reportings/customerInvoiceDetail', { params: payload })
}

export const getCustomerInvoiceReportsWaTemplate = (payload) => {
  return axios.get('/reportings/customerInvoice/whatsapp', { params: payload })
}

export const getCustomerInvoiceReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/customerInvoice/email', { params: payload })
}

export const sendCustomerInvoiceReportsEmail = (payload, data) => {
  return axios.post('/reportings/customerInvoice/email', data, { params: payload })
}

export const exportCustomerInvoiceReports = (params) => {
  return axios.get('/reportings/customerInvoice', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const profitabilityPerInvoiceReports = (payload) => {
  return axios.get('/reportings/invoiceProfitability', { params: payload })
}

export const profitabilityPerInvoiceGrandTotalReports = (payload) => {
  return axios.get('/reportings/invoiceProfitability/grandTotal', { params: payload })
}

export const getProfitabilityPerInvoiceReportsWaTemplate = (payload) => {
  return axios.get('/reportings/invoiceProfitability/whatsapp', { params: payload })
}

export const getProfitabilityPerInvoiceReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/invoiceProfitability/email', { params: payload })
}

export const sendProfitabilityPerInvoiceReportsEmail = (payload, data) => {
  return axios.post('/reportings/invoiceProfitability/email', data, { params: payload })
}

export const exportProfitabilityPerInvoiceReports = (params) => {
  return axios.get('/reportings/invoiceProfitability', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const incomePerCustomerReports = (payload) => {
  return axios.get('/reportings/incomePerCustomer', { params: payload })
}

export const incomePerCustomerDetailReports = (payload) => {
  return axios.get('/reportings/incomePerCustomerDetail', { params: payload })
}

export const getIncomePerCustomerReportsWaTemplate = (payload) => {
  return axios.get('/reportings/incomePerCustomer/whatsapp', { params: payload })
}

export const getIncomePerCustomerReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/incomePerCustomer/email', { params: payload })
}

export const sendIncomePerCustomerReportsEmail = (payload, data) => {
  return axios.post('/reportings/incomePerCustomer/email', data, { params: payload })
}

export const exportIncomePerCustomerReports = (params) => {
  return axios.get('/reportings/incomePerCustomer', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const expensePerContactReports = (payload) => {
  return axios.get('/reportings/expensePerContact', { params: payload })
}

export const exportExpensePerContactReports = (params) => {
  return axios.get('/reportings/expensePerContact', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const salesPerProductReports = (payload) => {
  return axios.get('/reportings/salesPerProduct', { params: payload })
}

export const salesPerProductDetailReports = ({ id, ...payload }) => {
  return axios.get(`/reportings/salesPerProduct/${id}`, { params: payload })
}

export const getSalesPerProductReportsWaTemplate = (payload) => {
  return axios.get('/reportings/salesPerProduct/whatsapp', { params: payload })
}

export const getSalesPerProductReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/salesPerProduct/email', { params: payload })
}

export const sendSalesPerProductReportsEmail = (payload, data) => {
  return axios.post('/reportings/salesPerProduct/email', data, { params: payload })
}

export const exportSalesPerProductReports = (params) => {
  return axios.get('/reportings/salesPerProduct', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const returnPerProductReports = (params) => {
  return axios.get(`/reportings/returnPerProduct`, { params })
}

export const getReturnPerProductReportsWaTemplate = (params) => {
  return axios.get(`/reportings/returnPerProduct/whatsapp`, { params })
}

export const getReturnPerProductReportsEmailTemplate = (params) => {
  return axios.get(`/reportings/returnPerProduct/email`, { params })
}

export const sendReturnPerProductReportsEmail = (params, data) => {
  return axios.post(`/reportings/returnPerProduct/email`, data, { params })
}

export const exportReturnPerProductReports = (params) => {
  return axios.get(`/reportings/returnPerProduct`, { params, responseType: 'arraybuffer' })
}

export const purchaseReturnPerProductReports = (params) => {
  return axios.get(`/reportings/purchaseReturnPerProduct`, { params })
}

export const purchaseReturnPerProductDetailReports = ({ id, ...params }) => {
  return axios.get(`/reportings/purchaseReturnPerProduct/${id}`, { params })
}

export const getPurchaseReturnPerProductReportsWaTemplate = (params) => {
  return axios.get(`/reportings/purchaseReturnPerProduct/whatsapp`, { params })
}

export const getPurchaseReturnPerProductReportsEmailTemplate = (params) => {
  return axios.get(`/reportings/purchaseReturnPerProduct/email`, { params })
}

export const sendPurchaseReturnPerProductReportsEmail = (params, data) => {
  return axios.post(`/reportings/purchaseReturnPerProduct/email`, data, { params })
}

export const exportPurchaseReturnPerProductReports = (params) => {
  return axios.get(`/reportings/purchaseReturnPerProduct`, { params, responseType: 'arraybuffer' })
}

export const orderPerProductReports = (payload) => {
  return axios.get('/reportings/orderPerProduct', { params: payload })
}

export const getOrderPerProductReportsWaTemplate = (payload) => {
  return axios.get('/reportings/orderPerProduct/whatsapp', { params: payload })
}

export const getOrderPerProductReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/orderPerProduct/email', { params: payload })
}

export const sendOrderPerProductReportsEmail = (payload, data) => {
  return axios.post('/reportings/orderPerProduct/email', data, { params: payload })
}

export const exportOrderPerProductReports = (params) => {
  return axios.get('/reportings/orderPerProduct', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getSalesPerProductCategory = (payload) => {
  return axios.get('/reportings/salesPerProductCategory', { params: payload })
}

export const getSalesPerProductCategoryDetail = ({ id, params }) => {
  return axios.get(`/reportings/salesPerProductCategoryDetail/${id}`, { params })
}

export const exportSalesPerProductCategory = (queryPayload) => {
  return axios.get('/reportings/salesPerProductCategory', {
    params: queryPayload,
    responseType: 'arraybuffer',
  })
}
export const exportSalesPerProductCategoryWhatsapp = (queryPayload) => {
  return axios.get('/reportings/salesPerProductCategory/whatsapp', { params: queryPayload })
}
export const exportSalesPerProductCategoryEmail = (queryPayload) => {
  return axios.get('/reportings/salesPerProductCategory/email', { params: queryPayload })
}
export const postSalesPerProductCategoryEmail = (queryPayload, payload) => {
  return axios.post('/reportings/salesPerProductCategory/email', payload, { params: queryPayload })
}

export const purchasesPerVendorReports = (payload) => {
  return axios.get('/reportings/purchasesPerVendor', { params: payload })
}

export const purchasesPerVendorDetailReports = (payload) => {
  return axios.get('/reportings/purchasesPerVendorDetail', { params: payload })
}

export const getPurchasePerVendorReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchasePerVendor/whatsapp', { params: payload })
}

export const getPurchasePerVendorReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchasePerVendor/email', { params: payload })
}

export const sendPurchasePerVendorReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchasePerVendor/email', data, { params: payload })
}

export const exportPurchasesPerVendorReports = (params) => {
  return axios.get('/reportings/purchasesPerVendor', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const purchasesPerProductReports = (payload) => {
  return axios.get('/reportings/purchasesPerProduct', { params: payload })
}

export const purchasesPerProductDetailReports = ({ id, ...payload }) => {
  return axios.get(`/reportings/purchasesPerProduct/${id}`, { params: payload })
}

export const getPurchasePerProductReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchasePerProduct/whatsapp', { params: payload })
}

export const getPurchasePerProductReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchasePerProduct/email', { params: payload })
}

export const sendPurchasePerProductReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchasePerProduct/email', data, { params: payload })
}

export const exportPurchasesPerProductReports = (params) => {
  return axios.get('/reportings/purchasesPerProduct', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const supplierInvoiceReports = (payload) => {
  return axios.get('/reportings/supplierInvoice', { params: payload })
}

export const getSupplierInvoiceReportsWaTemplate = (payload) => {
  return axios.get('/reportings/supplierInvoice/whatsapp', { params: payload })
}

export const getSupplierInvoiceReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/supplierInvoice/email', { params: payload })
}

export const sendSupplierInvoiceReportsEmail = (payload, data) => {
  return axios.post('/reportings/supplierInvoice/email', data, { params: payload })
}

export const exportSupplierInvoiceReports = (params) => {
  return axios.get('/reportings/supplierInvoice', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const agedReceivableReports = (payload) => {
  return axios.get('/reportings/agedReceivable', { params: payload })
}

export const getAgedReceivableReportsWaTemplate = (payload) => {
  return axios.get('/reportings/agedReceivable/whatsapp', { params: payload })
}

export const getAgedReceivableReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/agedReceivable/email', { params: payload })
}

export const sendAgedReceivableReportsEmail = (payload, data) => {
  return axios.post('/reportings/agedReceivable/email', data, { params: payload })
}

export const exportAgedReceivableReports = (params) => {
  return axios.get('/reportings/agedReceivable', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const agedReceivableDetailReports = ({ id, payload }) => {
  return axios.get(`/reportings/agedReceivableDetail/${id}`, { params: payload })
}

export const exportAgedReceivableDetailReports = (params) => {
  const { id, ...restParams } = params
  return axios.get(`/reportings/agedReceivableDetail/${id}`, {
    params: cleanBlankValue(restParams),
    responseType: 'arraybuffer',
  })
}

export const salesPerPeriodReports = (payload) => {
  return axios.get('/reportings/salesPerPeriod', { params: payload })
}

export const getSalesPerPeriodReportsWaTemplate = (payload) => {
  return axios.get('/reportings/salesPerPeriod/whatsapp', { params: payload })
}

export const getSalesPerPeriodReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/salesPerPeriod/email', { params: payload })
}

export const sendSalesPerPeriodReportsEmail = (payload, data) => {
  return axios.post('/reportings/salesPerPeriod/email', data, { params: payload })
}

export const exportSalesPerPeriodReports = (params) => {
  return axios.get('/reportings/salesPerPeriod', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const purchasesPerPeriodReports = (payload) => {
  return axios.get('/reportings/purchasesPerPeriod', { params: payload })
}

export const getPurchasesPerPeriodReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchasesPerPeriod/whatsapp', { params: payload })
}

export const getPurchasesPerPeriodReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchasesPerPeriod/email', { params: payload })
}

export const sendPurchasesPerPeriodReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchasesPerPeriod/email', data, { params: payload })
}

export const exportPurchasesPerPeriodReports = (params) => {
  return axios.get('/reportings/purchasesPerPeriod', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const agedPayableReports = (payload) => {
  return axios.get('/reportings/agedPayable', { params: payload })
}

export const getAgedPayableReportsWaTemplate = (payload) => {
  return axios.get('/reportings/agedPayable/whatsapp', { params: payload })
}

export const getAgedPayableReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/agedPayable/email', { params: payload })
}

export const sendAgedPayableReportsEmail = (payload, data) => {
  return axios.post('/reportings/agedPayable/email', data, { params: payload })
}

export const exportAgedPayableReports = (params) => {
  return axios.get('/reportings/agedPayable', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const agedPayableDetailReports = ({ id, payload }) => {
  return axios.get(`/reportings/agedPayableDetail/${id}`, { params: payload })
}

export const exportAgedPayableDetailReports = (params) => {
  const { id, ...restParams } = params
  return axios.get(`/reportings/agedPayableDetail/${id}`, {
    params: cleanBlankValue(restParams),
    responseType: 'arraybuffer',
  })
}

export const customerReceivableSnapshotReports = (payload) => {
  return axios.get('/reportings/customerReceivableSnapshot', { params: payload })
}

export const exportCustomerReceivableSnapshotReports = (params) => {
  return axios.get('/reportings/customerReceivableSnapshot', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const customerReceivableSnapshotDetailReports = ({ id, payload }) => {
  return axios.get(`/reportings/customerReceivableSnapshot/${id}`, { params: payload })
}

export const exportCustomerReceivableSnapshotDetailReports = (params) => {
  const { id, ...restParams } = params
  return axios.get(`/reportings/customerReceivableSnapshot/${id}`, {
    params: cleanBlankValue(restParams),
    responseType: 'arraybuffer',
  })
}

export const customerDebtSnapshotReports = (payload) => {
  return axios.get('/reportings/customerDebtSnapshot', { params: payload })
}

export const exportCustomerDebtSnapshotReports = (params) => {
  return axios.get('/reportings/customerDebtSnapshot', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const customerDebtSnapshotDetailReports = ({ id, payload }) => {
  return axios.get(`/reportings/customerDebtSnapshot/${id}`, { params: payload })
}

export const exportCustomerDebtSnapshotDetailReports = (params) => {
  const { id, ...restParams } = params
  return axios.get(`/reportings/customerDebtSnapshot/${id}`, {
    params: cleanBlankValue(restParams),
    responseType: 'arraybuffer',
  })
}

export const receivablePayableReports = (payload) => {
  return axios.get('/reportings/receivablePayable', { params: payload })
}

export const receivablePayableDetailReports = (payload) => {
  return axios.get('/reportings/receivablePayableDetail', { params: payload })
}

export const exportReceivablePayableReports = (params) => {
  return axios.get('/reportings/receivablePayable', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getReceivablePayableReportsWaTemplate = (payload) => {
  return axios.get('/reportings/receivablePayable/whatsapp', { params: payload })
}

export const getReceivablePayableReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/receivablePayable/email', { params: payload })
}

export const sendReceivablePayableReportsEmail = (payload, data) => {
  return axios.post('/reportings/receivablePayable/email', data, { params: payload })
}

export const expenseClaimReports = (payload) => {
  return axios.get('/reportings/expenseClaim', { params: payload })
}

export const exportExpenseClaimReports = (params) => {
  return axios.get('/reportings/expenseClaim', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const expenseClaimDetailReports = (id, payload) => {
  return axios.get(`/reportings/expenseClaimDetail/${id}`, { params: payload })
}

export const trialBalanceReports = (payload) => {
  return axios.get('/reportings/trialBalance', { params: payload })
}

export const exportTrialBalanceReports = (payload) => {
  return axios.get('/reportings/trialBalance', {
    params: cleanBlankValue(payload),
    responseType: 'arraybuffer',
  })
}

export const getTrialBalanceReportsWaTemplate = (payload) => {
  return axios.get('/reportings/trialBalance/whatsapp', { params: payload })
}

export const getTrialBalanceReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/trialBalance/email', { params: payload })
}

export const sendTrialBalanceReportsEmail = (payload, data) => {
  return axios.post('/reportings/trialBalance/email', data, { params: payload })
}

export const trialBalanceDetailReports = (id, payload) => {
  return axios.get(`/reportings/trialBalanceDetail/${id}`, { params: payload })
}

export const profitLossReports = (payload) => {
  return axios.get('/reportings/profitLoss', { params: payload })
}

export const getProfitLossReportsWaTemplate = (payload) => {
  return axios.get('/reportings/profitLoss/whatsapp', { params: payload })
}

export const getProfitLossReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/profitLoss/email', { params: payload })
}

export const sendProfitLossReportsEmail = (payload, data) => {
  return axios.post('/reportings/profitLoss/email', data, { params: payload })
}

export const exportProfitLossReports = (params) => {
  return axios.get('/reportings/profitLoss', { params, responseType: 'arraybuffer' })
}

export const consolidationProfitLossReports = (payload) => {
  return axios.get('/reportings/consolidationProfitLoss', { params: payload })
}

export const exportConsolidationProfitLossReports = (params) => {
  return axios.get('/reportings/consolidationProfitLoss', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const cashFlowReports = (payload) => {
  return axios.get('/reportings/cashFlow', { params: payload })
}

export const getCashFlowReportsWaTemplate = (payload) => {
  return axios.get('/reportings/cashFlow/whatsapp', { params: payload })
}

export const getCashFlowReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/cashFlow/email', { params: payload })
}

export const sendCashFlowReportsEmail = (payload, data) => {
  return axios.post('/reportings/cashFlow/email', data, { params: payload })
}

export const exportCashFlowReports = (params) => {
  return axios.get('/reportings/cashFlow', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const cashFlowProjectionReports = (payload) => {
  return axios.get('/reportings/cashFlowProjection', { params: payload })
}

export const exportCashFlowProjectionReports = (params) => {
  return axios.get('/reportings/cashFlowProjection', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const cashFlowDetailReports = (payload) => {
  return axios.get('/reportings/cashFlowDetail', { params: payload })
}

export const consolidationCashFlowReports = (payload) => {
  return axios.get('/reportings/consolidationCashFlow', { params: payload })
}

export const exportConsolidationCashFlowReports = (params) => {
  return axios.get('/reportings/consolidationCashFlow', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const balanceSheetReports = (payload) => {
  return axios.get('/reportings/balanceSheet', { params: payload })
}

export const getBalanceSheetReportsWaTemplate = (payload) => {
  return axios.get('/reportings/balanceSheet/whatsapp', { params: payload })
}

export const getBalanceSheetReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/balanceSheet/email', { params: payload })
}

export const sendBalanceSheetReportsEmail = (payload, data) => {
  return axios.post('/reportings/balanceSheet/email', data, { params: payload })
}

export const exportBalanceSheetReports = (params) => {
  return axios.get('/reportings/balanceSheet', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const consolidationBalanceSheetReports = (payload) => {
  return axios.get('/reportings/consolidationBalanceSheet', { params: payload })
}

export const consolidationBalanceSheetDetailReports = (params) => {
  return axios.get('/reportings/consolidationBalanceSheetDetail', { params })
}

export const exportConsolidationBalanceSheetReports = (params) => {
  return axios.get('/reportings/consolidationBalanceSheet', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const consolidationWorksheetReports = (payload) => {
  return axios.get('/reportings/consolidationWorksheet', { params: payload })
}

export const exportConsolidationWorksheetReports = (params) => {
  return axios.get('/reportings/consolidationWorksheet', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const equityMovementReports = (payload) => {
  return axios.get('/reportings/equityMovement', { params: payload })
}

export const getEquityMovementReportsWaTemplate = (payload) => {
  return axios.get('/reportings/equityMovement/whatsapp', { params: payload })
}

export const getEquityMovementReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/equityMovement/email', { params: payload })
}

export const sendEquityMovementReportsEmail = (payload, data) => {
  return axios.post('/reportings/equityMovement/email', data, { params: payload })
}

export const exportEquityMovementReports = (params) => {
  return axios.get('/reportings/equityMovement', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const executiveSummaryReports = (payload) => {
  return axios.get('/reportings/executiveSummary', { params: payload })
}

export const getExecutiveSummaryReportsWaTemplate = (payload) => {
  return axios.get('/reportings/executiveSummary/whatsapp', { params: payload })
}

export const getExecutiveSummaryReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/executiveSummary/email', { params: payload })
}

export const sendExecutiveSummaryReportsEmail = (payload, data) => {
  return axios.post('/reportings/executiveSummary/email', data, { params: payload })
}

export const exportExecutiveSummaryReports = (params) => {
  return axios.get('/reportings/executiveSummary', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const fixedAssetDetailReports = (payload) => {
  return axios.get('/reportings/fixedAssetDetail', { params: payload })
}

export const exportFixedAssetDetailReports = (params) => {
  return axios.get('/reportings/fixedAssetDetail', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const fixedAssetReports = (payload) => {
  return axios.get('/reportings/fixedAsset', { params: payload })
}

export const exportFixedAssetReports = (params) => {
  return axios.get(`/reportings/fixedAsset`, { params: cleanBlankValue(params) })
}

export const fixedAssetReleaseReports = (payload) => {
  return axios.get('/reportings/fixedAsset/releaseAsset', { params: payload })
}

export const exportFixedAssetReleaseReports = (params) => {
  return axios.get('/reportings/fixedAsset/releaseAsset', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const witholdingTaxReports = (payload) => {
  return axios.get('/reportings/witholdingTax', { params: payload })
}

export const exportWitholdingTaxReports = (params) => {
  return axios.get('/reportings/witholdingTax', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const salesDeliveryReports = (payload) => {
  return axios.get('/reportings/salesDelivery', { params: payload })
}

export const getSalesDeliveryReportsWaTemplate = (payload) => {
  return axios.get('/reportings/salesDelivery/whatsapp', { params: payload })
}

export const getSalesDeliveryReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/salesDelivery/email', { params: payload })
}

export const sendSalesDeliveryReportsEmail = (payload, data) => {
  return axios.post('/reportings/salesDelivery/email', data, { params: payload })
}

export const exportSalesDeliveryReports = (params) => {
  return axios.get('/reportings/salesDelivery', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const purchaseDeliveryReports = (payload) => {
  return axios.get('/reportings/purchaseDelivery', { params: payload })
}

export const getPurchaseDeliveryReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchaseDelivery/whatsapp', { params: payload })
}

export const getPurchaseDeliveryReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchaseDelivery/email', { params: payload })
}

export const sendPurchaseDeliveryReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchaseDelivery/email', data, { params: payload })
}

export const exportPurchaseDeliveryReports = (params) => {
  return axios.get('/reportings/purchaseDelivery', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const addBudgetReports = (data) => {
  return axios.post(`/reportings/budgets`, data)
}

export const deleteOnAddBudgetReportAttachment = (url) => {
  return axios.delete('/reportings/budgets/attachments', { data: { url } })
}

export const budgetReports = (payload) => {
  return axios.get('/reportings/budgets', { params: payload })
}

export const exportBudgetsReports = (params) => {
  return axios.get('/reportings/budgets', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const budgetDetailReports = (id, payload) => {
  return axios.get(`/reportings/budgets/${id}`, { params: payload })
}

export const editBudgetReports = (id, data) => {
  return axios.put(`/reportings/budgets/${id}`, data)
}

export const deleteOnEditBudgetReportAttachment = (id, url) => {
  return axios.delete(`/reportings/budgets/${id}/attachments`, { data: { url } })
}

export const deleteBudgetReports = (id) => {
  return axios.delete(`/reportings/budgets/${id}`)
}

export const approveBudgetReport = (id, data) => {
  return axios.post(`/reportings/budgets/${id}/approve`, data)
}

export const rejectBudgetReport = (id, data) => {
  return axios.post(`/reportings/budgets/${id}/reject`, data)
}

export const revertBudgetReport = (id, data) => {
  return axios.post(`/reportings/budgets/${id}/revert`, data)
}

export const budgetProfitLossReports = (payload) => {
  return axios.get('/reportings/budget/profitLoss', { params: payload })
}

export const budgetProfitLossDetailReports = (id, payload) => {
  return axios.get(`/reportings/budget/profitLoss/${id}`, { params: payload })
}

export const exportBudgetProfitLossDetailReports = (params) => {
  return axios.get(`/reportings/budget/profitLoss/${params.id}`, {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const salesDetailReports = (payload) => {
  return axios.get('/reportings/salesDetail', { params: payload })
}

export const getSalesDetailReportsWaTemplate = (payload) => {
  return axios.get('/reportings/salesDetail/whatsapp', { params: payload })
}

export const getSalesDetailReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/salesDetail/email', { params: payload })
}

export const sendSalesDetailReportsEmail = (payload, data) => {
  return axios.post('/reportings/salesDetail/email', data, { params: payload })
}

export const exportSalesDetailReports = (params) => {
  return axios.get('/reportings/salesDetail', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const purchaseDetailReports = (payload) => {
  return axios.get('/reportings/purchaseDetail', { params: payload })
}

export const getPurchaseDetailReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchaseDetail/whatsapp', { params: payload })
}

export const getPurchaseDetailReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchaseDetail/email', { params: payload })
}

export const sendPurchaseDetailReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchaseDetail/email', data, { params: payload })
}

export const exportPurchaseDetailReports = (params) => {
  return axios.get('/reportings/purchaseDetail', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const productProfitabilityReports = (payload) => {
  return axios.get('/reportings/productProfitability', { params: payload })
}

export const exportProductProfitabilityReports = (params) => {
  return axios.get('/reportings/productProfitability', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const invoicePaymentReports = (payload) => {
  return axios.get('/reportings/invoicesPayment', { params: payload })
}

export const invoicePaymentTotalReports = (payload) => {
  return axios.get('/reportings/invoicesPayment/total', { params: payload })
}

export const exportInvoicePaymentReports = (params) => {
  return axios.get('/reportings/invoicesPayment', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getInvoicePaymentReportsWaTemplate = (payload) => {
  return axios.get('/reportings/invoicesPayment/whatsapp', { params: payload })
}

export const getInvoicePaymentReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/invoicesPayment/email', { params: payload })
}

export const sendInvoicePaymentReportsEmail = (payload, data) => {
  return axios.post('/reportings/invoicesPayment/email', data, { params: payload })
}

export const purchaseInvoicePaymentReports = (payload) => {
  return axios.get('/reportings/purchaseInvoicesPayment', { params: payload })
}

export const purchaseInvoicePaymentTotalReports = (payload) => {
  return axios.get('/reportings/purchaseInvoicesPayment/total', { params: payload })
}

export const exportPurchaseInvoicePaymentReports = (params) => {
  return axios.get('/reportings/purchaseInvoicesPayment', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getPurchaseInvoicePaymentReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchaseInvoicesPayment/whatsapp', { params: payload })
}

export const getPurchaseInvoicePaymentReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchaseInvoicesPayment/email', { params: payload })
}

export const sendPurchaseInvoicePaymentReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchaseInvoicesPayment/email', data, { params: payload })
}

export const customerPaymentRecapReports = (payload) => {
  return axios.get('/reportings/customerPaymentRecap', { params: payload })
}

export const exportCustomerPaymentRecapReports = (params) => {
  return axios.get('/reportings/customerPaymentRecap', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getCustomerPaymentRecapReportsWaTemplate = (payload) => {
  return axios.get('/reportings/customerPaymentRecap/whatsapp', { params: payload })
}

export const getCustomerPaymentRecapReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/customerPaymentRecap/email', { params: payload })
}

export const sendCustomerPaymentRecapReportsEmail = (payload, data) => {
  return axios.post('/reportings/customerPaymentRecap/email', data, { params: payload })
}

export const exportProductSalesContacts = (queryPayload) => {
  return axios.get('/reportings/productSalesContacts', {
    params: queryPayload,
    responseType: 'arraybuffer',
  })
}
export const getProductSalesContacts = (queryPayload) => {
  return axios.get('/reportings/productSalesContacts', { params: queryPayload })
}
export const getProductSalesContactsDetails = (queryPayload) => {
  return axios.get('/reportings/productSalesContactsDetail', { params: queryPayload })
}

export const getProductSalesContactWATemplate = (queryPayload) => {
  return axios.get('/reportings/productSalesContacts/whatsapp', { params: queryPayload })
}
export const getProductSalesContactEmailTemplate = (queryPayload) => {
  return axios.get('/reportings/productSalesContacts/email', { params: queryPayload })
}
export const postProductSalesContactEmailReport = (queryPayload, data) => {
  return axios.post('/reportings/productSalesContacts/email', data, { params: queryPayload })
}

export const getProductPurchasesContactsDetails = (queryPayload) => {
  return axios.get('/reportings/productPurchasesContactsDetail', { params: queryPayload })
}
export const getProductPurchasesContacts = (queryPayload) => {
  return axios.get('/reportings/productPurchasesContacts', { params: queryPayload })
}
export const exportProductPurchasesContacts = (queryPayload) => {
  return axios.get('/reportings/productPurchasesContacts', {
    params: queryPayload,
    responseType: 'arraybuffer',
  })
}

export const getProductPurchasesContactWATemplate = (queryPayload) => {
  return axios.get('/reportings/productPurchasesContacts/whatsapp', { params: queryPayload })
}

export const getProductPurchasesContactEmailTemplate = (queryPayload) => {
  return axios.get('/reportings/productPurchasesContacts/email', { params: queryPayload })
}
export const postProductPurchasesContactEmailReport = (queryPayload, data) => {
  return axios.post('/reportings/productPurchasesContacts/email', data, { params: queryPayload })
}

export const inventoryProductSerialStockMovementDetailReports = (payload) => {
  return axios.get('/reportings/inventoryProductSerialStockMovementDetail', { params: payload })
}

export const inventoryProductSerialStockDetailReports = (params) => {
  return axios.get('/reportings/inventoryProductSerialStockDetail', {
    params: cleanBlankValue(params),
  })
}

export const inventoryProductSerialExpiresSoonReports = (queryPayload) => {
  return axios.get('/reportings/inventoryProductSerialExpiresSoon', { params: queryPayload })
}

export const inventoryProductSerialExpiryAgeReports = (payload) => {
  return axios.get('/reportings/inventoryProductSerialExpiryAge', { params: payload })
}

export const inventoryProductSerialHistoryReports = (payload) => {
  return axios.get('/reportings/inventoryProductSerialHistory', { params: payload })
}

export const dutyStampsReports = (payload) => {
  return axios.get('/reportings/stamps', { params: payload })
}

export const getActivityTeamReports = (queryPayload) => {
  return axios.get('/reportings/activity-team', { params: queryPayload })
}

export const getActivityTeamTransactionReports = (queryPayload) => {
  return axios.get('/reportings/activity-team/transactions', { params: queryPayload })
}

export const purchaseOrderPerProductReports = (payload) => {
  return axios.get('/reportings/purchaseOrderPerProduct', { params: payload })
}

export const purchaseOrderPerProductDetailReports = ({ id, ...payload }) => {
  return axios.get(`/reportings/purchaseOrderPerProduct/${id}`, { params: payload })
}

export const getPurchaseOrderPerProductReportsWaTemplate = (payload) => {
  return axios.get('/reportings/purchaseOrderPerProduct/whatsapp', { params: payload })
}

export const getPurchaseOrderPerProductReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/purchaseOrderPerProduct/email', { params: payload })
}

export const sendPurchaseOrderPerProductReportsEmail = (payload, data) => {
  return axios.post('/reportings/purchaseOrderPerProduct/email', data, { params: payload })
}

export const exportPurchaseOrderPerProductReports = (params) => {
  return axios.get('/reportings/purchaseOrderPerProduct', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const getGeneralLedgerOverviewReports = (params) => {
  return axios.get('/reportings/generalLedgerOverview', { params })
}

export const getCashFlowEndOfPeriod = (params) => {
  return axios.get('/reportings/cashFlowEndOfPeriod', { params })
}

export const creditMemoReports = (params) => {
  return axios.get('/reportings/creditMemo', { params })
}

export const exportCreditMemoReports = (params) => {
  return axios.get('/reportings/creditMemo', {
    params: cleanBlankValue({ ...params, export: params.type, type: null }),
    responseType: 'arraybuffer',
  })
}

export const getCreditMemoReportsWaTemplate = (payload) => {
  return axios.get('/reportings/creditMemo/whatsapp', { params: payload })
}

export const getCreditMemoReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/creditMemo/email', { params: payload })
}

export const sendCreditMemoReportsEmail = (payload, data) => {
  return axios.post('/reportings/creditMemo/email', data, { params: payload })
}

export const debitMemoReports = (params) => {
  return axios.get('/reportings/debitMemo', { params })
}

export const exportDebitMemoReports = (params) => {
  return axios.get('/reportings/debitMemo', {
    params: cleanBlankValue({ ...params, export: params.type, type: null }),
    responseType: 'arraybuffer',
  })
}

export const getDebitMemoReportsWaTemplate = (payload) => {
  return axios.get('/reportings/debitMemo/whatsapp', { params: payload })
}

export const getDebitMemoReportsEmailTemplate = (payload) => {
  return axios.get('/reportings/debitMemo/email', { params: payload })
}

export const sendDebitMemoReportsEmail = (payload, data) => {
  return axios.post('/reportings/debitMemo/email', data, { params: payload })
}

export const balanceReceivableTerminReports = (params) => {
  return axios.get('/reportings/balanceReceivableTermin', { params })
}

export const exportBalanceReceivableTerminReports = (params) => {
  return axios.get('/reportings/balanceReceivableTermin', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const balanceReceivableTerminDetailReports = (payload) => {
  const { id, ...params } = payload
  return axios.get(`/reportings/balanceReceivableTerminDetail/${id}`, { params })
}

export const exportBalanceReceivableTerminDetailReports = (params) => {
  const { id, ...payload } = cleanBlankValue(params)
  return axios.get(`/reportings/balanceReceivableTerminDetail/${id}`, {
    params: payload,
    responseType: 'arraybuffer',
  })
}

export const balancePayableTerminReports = (params) => {
  return axios.get('/reportings/balancePayableTermin', { params })
}

export const exportBalancePayableTerminReports = (params) => {
  return axios.get('/reportings/balancePayableTermin', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const balancePayableTerminDetailReports = (payload) => {
  const { id, ...params } = payload
  return axios.get(`/reportings/balancePayableTerminDetail/${id}`, { params })
}

export const exportBalancePayableTerminDetailReports = (params) => {
  const { id, ...payload } = cleanBlankValue(params)
  return axios.get(`/reportings/balancePayableTerminDetail/${id}`, {
    params: payload,
    responseType: 'arraybuffer',
  })
}

export const salesPerRegionReports = (params) => {
  return axios.get('/reportings/salesPerRegion', { params })
}

export const exportSalesPerRegionReports = (params) => {
  return axios.get('/reportings/salesPerRegion', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const purchasePerRegionReports = (params) => {
  return axios.get('/reportings/purchasePerRegion', { params })
}

export const exportPurchasePerRegionReports = (params) => {
  return axios.get('/reportings/purchasePerRegion', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const productsPriceHistoryReports = ({ params }) => {
  return axios.get('/finance/reportings/productsPriceHistory', { params })
}

export const inventoryTurnoverReports = (payload) => {
  return axios.get('/reportings/inventoryTurnover', { params: payload })
}

export const inventoryTurnoverDetailReports = ({ id, params }) => {
  return axios.get(`/reportings/inventoryTurnover/${id}`, { params })
}

export const exportInventoryTurnoverReports = (params) => {
  return axios.get('/reportings/inventoryTurnover', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const paymentConnectKledoDisbursment = (params) => {
  return axios.get('/reportings/paymentConnectKledoDisbursement', { params })
}

export const paymentConnectKledoDisbursmentListDetail = (params) => {
  return axios.get('/reportings/paymentConnectKledoDisbursement/listDetail', { params })
}

export const exportPaymentConnectKledoDisbursment = (params) => {
  return axios.get('/reportings/paymentConnectKledoDisbursement', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const paymentConnectKledoTransaction = (params) => {
  return axios.get('/reportings/paymentConnectKledoTransaction', { params })
}

export const paymentConnectKledoTransactionListDetail = (params) => {
  return axios.get('/reportings/paymentConnectKledoTransaction/listDetail', { params })
}

export const exportPaymentConnectKledoTransaction = (params) => {
  return axios.get('/reportings/paymentConnectKledoTransaction', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

// material reports

export const requestFulfillmentReports = (params) => {
  return axios.get('/finance/materialReports/requestFulfillment', { params })
}

export const usageHistoryReports = (params) => {
  return axios.get('/finance/materialReports/usageHistory', { params })
}

export const usagePerProjectReports = (params) => {
  return axios.get('/finance/materialReports/usagePerProject', { params })
}

export const exportRequestFulfillmentReports = (params) => {
  return axios.get('/finance/materialReports/requestFulfillment/export', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const exportUsageHistoryReports = (params) => {
  return axios.get('/finance/materialReports/usageHistory/export', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const exportUsagePerProjectReports = (params) => {
  return axios.get('/finance/materialReports/usagePerProject/export', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}

export const pricelistUnitConversionReports = (params) => {
  return axios.get('/reportings/pricelistUnitConversion', { params })
}

export const exportPricelistUnitConversionReports = (params) => {
  return axios.get('/reportings/pricelistUnitConversion', {
    params: cleanBlankValue(params),
    responseType: 'arraybuffer',
  })
}
